import React, { useState } from "react";
import Acesso from "../acesso-rapido/AcessoRapido";
import { useAuth } from "../../hooks/useAuth";
import { FiUser, FiMenu, FiX } from "react-icons/fi";

import "../../components/menu-lateral/Style.css";

export default function MenuLateral() {
  const { user, account } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const agency = account?.bankBranch || '0000';
  const accountNumber = account?.bankAccount || '0000000000';
  const accountDigit = account?.bankAccountDigit || '0';
  const accountBank = account?.bank || '000';

  const getAvatar = () => {
    const isMainUser = user?.isMainAccess;

    if (isMainUser && user?.avatar) {
      return <img src={user.avatar.url} alt="" />;
    }

    if (!isMainUser && user?.companyUser?.avatar) {
      return <img src={user.companyUser.avatar.url} alt="" />;
    }

    return <FiUser size={20} />;
  };

  const getName = () => {
    if (user?.companyUser?.name) {
      return user.companyUser.name.split(" ")[0];
    }
    return user?.name?.split(" ")[0];
  };

  return (
    <>
      {/* Barra fina quando fechado */}
      <div className={`menu-rail ${isOpen ? "hidden" : ""}`}>
        <button className="menu-rail-toggle" onClick={() => setIsOpen(true)}>
          <FiMenu size={20} />
        </button>
      </div>

      {/* Menu principal */}
      <div className={`menu ${isOpen ? "open" : ""}`}>
        <div className="d-flex header-menu">
          <div className="perfil">
            <div className="client-icon">
              {getAvatar()}
            </div>
          </div>

          <div
            className="menu-name"
            title={user?.companyUser?.name || user?.name}
          >
            <div className="menu-name-text">
              Olá, {getName()}
            </div>
          </div>

          {/* Botão fechar – lateral direita */}
          <button
            className="menu-side-toggle"
            onClick={() => setIsOpen(false)}
          >
            <FiX size={18} />
          </button>
        </div>

        {/* resto do menu */}
      </div>


      {/* Overlay */}
      {isOpen && <div className="menu-overlay" onClick={() => setIsOpen(false)} />}

      <div className={`menu ${isOpen ? "open" : ""}`}>
        <div className="d-flex header-menu">
          <div className="perfil">
            <div className="client-icon">
              {getAvatar()}
            </div>
          </div>

          <div className="menu-name" title={user?.companyUser?.name || user?.name}>
            <div>Olá, {getName()}</div>
          </div>

          {/* Botão fechar no mobile */}
          <button className="menu-close" onClick={() => setIsOpen(false)}>
            <FiX size={20} />
          </button>
        </div>

        <div className="conta">
          <div className="col-md-3">
            <p className="label">Banco</p>
            <p>{accountBank}</p>
          </div>
          <div className="col-md-3">
            <p className="label">Ag</p>
            <p>{agency}</p>
          </div>
          <div className="col-md-6">
            <p className="label">Conta</p>
            <p>{accountNumber}-{accountDigit}</p>
          </div>
        </div>

        <Acesso />
      </div>
    </>
  );
}
